var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{directives:[{name:"close-popover",rawName:"v-close-popover.all",modifiers:{"all":true}}],staticClass:"grid",class:{
    'md:grid-cols-content-boards-home': _vm.isUser
  },attrs:{"id":"boards-home"}},[(_vm.isUser)?_c('sidebar-navigation',{staticClass:"fixed w-sidebar"}):_vm._e(),_c('router-view',{staticClass:"col-start-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }